module.exports = __webpack_public_path__ + "img/DSCN0273.87ed3825.jpg";